import * as React from 'react';
import { SVGProps } from 'react';

const IconDragSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m9 4 2 2-2 2V7H7v2h1l-2 2-2-2h1V7H3v1L1 6l2-2v1h2V3H4l2-2 2 2H7v2h2V4z" />
  </svg>
);
export default IconDragSizeXs;
